/*jshint esversion: 6 */
import Vue from 'vue';
import axios from 'axios';
// import i18n from '../../plugins/i18n';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  error: '',
  loading: false,
  // twork_packages: {},
  invoiceable_twork_packages: {},
  invoice_preview: { iwork_packages: []},
  tags: {},
  // step_type, id, description,
  invoice: {},
  image_confidence: {
    confidence_drywall: 0,
    confidence_electrical: 0,
    confidence_paint: 0
  },
  cost_strategies: {
    1: {
      value: 1,
      text: 'Flat Rate',
      description: 'A fixed price for labour and materials.',
      elements: [
        {tag: 'total', optional: {is_disabled: true}}
      ],
    },
    2: {
      value: 2,
      text: 'Unit Price',
      description: 'A fixed price per square meter. Hourly Wage and Material Price inclusive.',
      elements: [
        {tag: 'material', optional: {}, ppermissons: []},
        {tag: 'equals', optional: {}},
        {tag: 'total', optional: {is_disabled: true}}
      ],
    },
    3: {
      value: 3,
      text: 'Hourly Wages',
      description: 'Price per one hour of work.',
      elements: [
        {tag: 'labour', optional: {}},
        {tag: 'equals', optional: {}},
        {tag: 'total', optional: {is_disabled: true}}
      ],
    },
    4 :{
      value: 4,
      text: 'Material Price',
      description: 'Just the price of the Materials.',
      elements: [
        {tag: 'material', optional: {}},
        {tag: 'equals', optional: {}},
        {tag: 'total', optional: {is_disabled: true}}
      ],
    },
    5 :{
      value: 5,
      text: 'Material Price and Hourly Wages',
      description: 'Hourly Wages plus the price of the Materials.',
      elements: [
        {tag: 'material', optional: {}},
        {tag: 'sum', optional: {}},
        {tag: 'labour', optional: {}},
        {tag: 'equals', optional: {}},
        {tag: 'total', optional: {is_disabled: true}}
      ],
    }
  },
  budget_elements: {
    total: {label: 'Total', id: 'Total', icon: 'wallet'},
    material: {label: 'Material', id: 'Material', icon: 'packet'},
    labour: {label: 'Labour', id: 'Labour', icon: 'person-helmet'}
  },
  tendered_elements: {
    total: {label: 'Total', id: 'Total', icon: 'shopping-cart'},
    material: {label: 'Material', id: 'Material', icon: 'packet'},
    labour: {label: 'Labour', id: 'Labour', icon: 'shopping-cart'}
  },
  paid_out_elements: {
    total: {label: 'Total', id: 'Total', icon: 'money'},
    material: {label: 'Material', id: 'Material', icon: 'packet'},
    labour: {label: 'Labour', id: 'Labour', icon: 'money'}
  },
  total_elements: {
    budget_total: { label: 'Total Budget', id: 'Total Budget', icon: 'wallet'},
    tendered_total: { label: 'Tendered Costs', id: 'Tendered Costs', icon: 'shopping-cart'},
    paid_out_total: { label: 'Paid Out', id: 'Paid Out', icon: 'money'}
  },
  operators: {
    equals: { operator: '=' },
    sum: { operator: '+' },
    divides: { operator: '/' },
  }
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getTest: (state, getters, rootState) => {
    return rootState.Ultra;
  },
  // TODO: Getter für tags eines workpackages
  //Getters to local state
  getInvoiceableTWorkPackages: (state) => {
    return state.invoiceable_twork_packages;
  },
  getInvoicePreview: (state) => {
    return state.invoice_preview;
  },
  getInvoice: (state) => {
    return state.invoice;
  },
  getCostStrategy: (state) => (cost_strategy) => {
    let wp_cost_strategy = {};
    if (cost_strategy.id === undefined) {
      wp_cost_strategy = state.cost_strategies[1];
    }
    else {
      wp_cost_strategy = state.cost_strategies[cost_strategy.id];
    }
    return wp_cost_strategy;
  },
  getEquation: (state, getters, rootState, rootGetters) => (payload) => {
    let wp = rootState.Ultra[`${payload.prefix}workpackages`][payload.workpackage_id];
    let elements = Object.assign(state[payload.type + '_elements'], state.operators);
    let equation = [];
    for (var i = 0; i < payload.structure.length; i++) {
      let element = JSON.parse(JSON.stringify(elements[payload.structure[i].tag]));
      element.input_type = 'number';
      element.input_mode = 'decimal';
      if(!Object.keys(state.operators).includes(payload.structure[i].tag)) {
        if(payload.type === 'total') {
          element.value = wp[['costs', payload.structure[i].tag].join('_')];
        } else {
          element.value = wp[['costs',payload.type,payload.structure[i].tag].join('_')];
        }
        element.is_disabled =
          !rootGetters['Project/isEditMode'] &&
          (!rootGetters['Project/hasProjectPermission']({project_id: payload.project_id, ppermission: 'Update Work Package ' + (payload.type.substring(0, 1).toUpperCase() + payload.type.substring(1).toLowerCase()).replace("_", " ") + ' Costs'}) ||
          !(rootGetters['Project/hasProjectPermission']({project_id: payload.project_id, ppermission: 'Update Own Work Package ' + (payload.type.substring(0, 1).toUpperCase() + payload.type.substring(1).toLowerCase()).replace("_", " ") + ' Costs'}) &&
          rootGetters['Project/getOwnTWorkPackages'](payload.project_id).includes(payload.workpackage_id)));
        element = Object.assign(element, payload.structure[i].optional);
      }
      equation.push(element);
    }
    return equation;
  },
  // OLD
  getTWPBudgetPrice: (state, getters, rootState) => (twork_package_id) => {
    let wp = rootState.Ultra.tworkpackages[twork_package_id];
    switch (wp.cost_strategy.id) {
      case 1:
        // 'Flat Rate'
        return wp.costs_budget_total;
      case 2:
        // 'Unit Price'
        return wp.costs_budget_material * wp.quantity_value;
      case 3:
        // 'Hourly Wages'
        return (wp.manpower_planned * wp.time_effort_planned) * wp.costs_budget_labour;
      case 4:
        // 'Material Price'
        return wp.costs_budget_material;
      case 5:
        // 'Material Price and Hourly Wages'
        return ((wp.manpower_planned * wp.time_effort_planned) * wp.costs_budget_labour) + wp.costs_budget_material;
      default:
        return 0;
    }
  },
  // OLD
  getTWPTenderedPrice: (state, getters, rootState) => (twork_package_id) => {
    let wp = rootState.Ultra.tworkpackages[twork_package_id];
    switch (wp.cost_strategy.id) {
      case 1:
        // 'Flat Rate'
        return wp.costs_tendered_total;
      case 2:
        // 'Unit Price'
        return wp.costs_tendered_material * wp.quantity_value;
      case 3:
        // 'Hourly Wages'
        return (wp.manpower_planned * wp.time_effort_planned) * wp.costs_tendered_labour;
      case 4:
        // 'Material Price'
        return wp.costs_tendered_material;
      case 5:
        // 'Material Price and Hourly Wages'
        return ((wp.manpower_planned * wp.time_effort_planned) * wp.costs_tendered_labour) + wp.costs_tendered_material;
      default:
        return 0;
    }
  },
  // OLD
  getTWPToBePaidPrice: (state, getters, rootState) => (twork_package_id) => {
    let wp = rootState.Ultra.tworkpackages[twork_package_id];
    switch (wp.cost_strategy.id) {
      case 1:
        // 'Flat Rate'
        return wp.costs_tendered_total;
      case 2:
        // 'Unit Price'
        return wp.costs_tendered_material * wp.quantity_value;
      case 3:
        // 'Hourly Wages'
        return (wp.manpower_actual * wp.duration_actual) * wp.manpower_actual * wp.costs_tendered_labour;
      case 4:
        // 'Material Price'
        return wp.costs_tendered_material;
      case 5:
        // 'Material Price and Hourly Wages'
        return ((wp.manpower_actual * wp.duration_actual) * wp.manpower_actual * wp.costs_tendered_labour) + wp.costs_tendered_material;
      default:
        return 0;
    }
  },
  isLoading: ( state ) => state.loading,
  isStandardIcon: (state, getters, rootState) => (icon) => {
    return rootState.Ultra.standard_icons.includes(icon);
  },
  //Getters to ultra store state
  getTWorkpackageColors: (state, getters, rootState) => {
    let colors = [];
    for(let twork_package_id in rootState.Ultra.tworkpackages) {
      if (!colors.find(color => color.value === rootState.Ultra.tworkpackages[twork_package_id].color)) {
        let my_color = rootState.Ultra.tworkpackages[twork_package_id].color;
        colors.push({value: my_color, tooltip: my_color, language: false});
      }
    }
    // Should this be in the tworkpackage name getter?
    for(let wbwork_package_id in rootState.Ultra.wbworkpackages) {
      if (!colors.find(color => color.value === rootState.Ultra.wbworkpackages[wbwork_package_id].color)) {
        let my_color = rootState.Ultra.wbworkpackages[wbwork_package_id].color;
        colors.push({value: my_color, tooltip: my_color });
      }
    }
    return colors;
  },
  getTWorkpackageTokens: (state, getters, rootState) => {
    let tokens = [];
    for(let twork_package_id in rootState.Ultra.tworkpackages) {
      if (!tokens.find(token => token.name === rootState.Ultra.tworkpackages[twork_package_id].token)) {
        let my_token = rootState.Ultra.tworkpackages[twork_package_id].token;
        tokens.push({name: my_token, tooltip: my_token });
      }
    }
    // Should this be in the tworkpackage name getter?
    for(let wbwork_package_id in rootState.Ultra.wbworkpackages) {
      if (!tokens.find(token => token.name === rootState.Ultra.wbworkpackages[wbwork_package_id].token)) {
        let my_token = rootState.Ultra.wbworkpackages[wbwork_package_id].token;
        tokens.push({name: my_token, tooltip: my_token });
      }
    }
    return tokens;
  },
  getTWorkpackageIcons: (state, getters, rootState) => {
    let icons = [];
    for(let twork_package_id in rootState.Ultra.tworkpackages) {
      if (!icons.find(icon => icon.value === rootState.Ultra.tworkpackages[twork_package_id].icon)) {
        let my_icon = rootState.Ultra.tworkpackages[twork_package_id].icon;
        icons.push({icon: my_icon, value: my_icon, tooltip: my_icon, color: 'grey darken-1', wp_icon: true, language: false});
      }
    }
    // Should this be in the tworkpackage name getter?
    for(let wbwork_package_id in rootState.Ultra.wbworkpackages) {
      if (!icons.find(icon => icon.value === rootState.Ultra.wbworkpackages[wbwork_package_id].icon)) {
        let my_icon = rootState.Ultra.wbworkpackages[wbwork_package_id].icon;
        icons.push({icon: my_icon, value: my_icon, tooltip: my_icon, color: 'grey darken-1', wp_icon: true});
      }
    }
    return icons;
  },
  getTWorkpackageNames: (state, getters, rootState) => {
    let names = [];
    for(let twork_package_id in rootState.Ultra.tworkpackages) {
      if (!names.find(name => name.name === rootState.Ultra.tworkpackages[twork_package_id].name)) {
        let my_name = rootState.Ultra.tworkpackages[twork_package_id].name;
        names.push({name: my_name, tooltip: my_name });
      }
    }
    // Should this be in the tworkpackage name getter?
    for(let wbwork_package_id in rootState.Ultra.wbworkpackages) {
      if (!names.find(name => name.name === rootState.Ultra.wbworkpackages[wbwork_package_id].name)) {
        let my_name = rootState.Ultra.wbworkpackages[wbwork_package_id].name;
        names.push({name: my_name, tooltip: my_name });
      }
    }
    return names;
  },

  getTWorkPackage: (state, getters, rootState) => (twork_package_id) => {
    return rootState.Ultra.tworkpackages[twork_package_id];
  },
  getTWorkPackages: (state, getters, rootState) => (payload) => {
    if (payload.ids) {
      return payload.ids.map(id => rootState.Ultra.tworkpackages[id]);
    } else {
      return Object.keys(rootState.Ultra.tworkpackages).map(id => rootState.Ultra.tworkpackages[id]);
    }
  },
  getUniqueTWorkPackagesByProject: (state, getters, rootState) => (project_id) => {
    let twp_set = {};
    rootState.Ultra.projects[project_id].trains.forEach((train_id) => {
      rootState.Ultra.trains[train_id].taktareas.forEach((taktarea_id) => {
        rootState.Ultra.taktareas[taktarea_id].twaggons.forEach((twaggon_id) => {
          rootState.Ultra.twaggons[twaggon_id].tworkpackages.forEach((tworkpackage_id) => {
            let twp = rootState.Ultra.tworkpackages[tworkpackage_id];
            let key = twp.color + twp.token + twp.icon;
            if ( !twp_set[key] ) {
              twp_set[key] = {
                color: twp.color,
                token: twp.token,
                icon: twp.icon,
              };
            }
          });
        });
      });
    });
    return Object.values(twp_set);
  },
  getUniqueTWorkPackagesByTrain: (state, getters, rootState, rootGetters) => (train) => {    
    const filterLegend = rootGetters['View/isTaktplanShowOnlyFilteredWorkpackages'];
    const settings = rootGetters['ProjectStatistics/getStatisticSettings'];
    
    let twp_set = {};
    if (train.taktareas) {
      rootState.Ultra.trains[train.id].taktareas.forEach((taktarea_id) => {
        rootState.Ultra.taktareas[taktarea_id].twaggons.forEach((twaggon_id) => {
          rootState.Ultra.twaggons[twaggon_id].tworkpackages.forEach((tworkpackage_id) => {
            let twp = rootState.Ultra.tworkpackages[tworkpackage_id];
            let key = twp.color + twp.token + twp.icon + twp.name;
            if (!twp_set[key] && (!filterLegend || isInFilter(settings, twp))) {
              twp_set[key] = {
                color: twp.color,
                token: twp.token,
                icon: twp.icon,
                name: twp.name,
              };
            }
          });
        });
      });
    } else if (train.wblines) {
      rootState.Ultra.wbgroups[train.id].wblines.forEach((wbline_id) => {
        rootState.Ultra.wblines[wbline_id].wbworkpackages.forEach((wbworkpackage_id) => {
            let twp = rootState.Ultra.wbworkpackages[wbworkpackage_id];
            let key = twp.color + twp.token + twp.icon + twp.name;
            if (!twp_set[key] && (!filterLegend || isInFilter(settings, twp))) {
              twp_set[key] = {
                color: twp.color,
                token: twp.token,
                icon: twp.icon,
                name: twp.name,
              };
            }
        });
      });
    }
    return Object.values(twp_set);
  },
  getQRCodes: (state, getters, rootState) => (payload) => {
    if (rootState.Ultra[`${payload.prefix}workpackages`][payload.workpackage_id] && rootState.Ultra[`${payload.prefix}workpackages`][payload.workpackage_id].tags) {
      let tags = [];
      // get QR Codes of twork_package_loading
      rootState.Ultra[`${payload.prefix}workpackages`][payload.workpackage_id].tags.forEach((tag_id) => {
        let tag = JSON.parse(JSON.stringify(rootState.Ultra.tags[tag_id]));
        tag.person_string = `${tag.user_email.last_name}, ${tag.user_email.first_name}`;
        let date = new Date(tag.created.split(' UTC')[0]);
        let date_string =
        rootState.Ultra.week_days_full[date.getDay()] + ', ' +
        date.getDate() + '. ' +
        rootState.Ultra.months[date.getMonth()] + ' ' +
        date.getFullYear();
        tag.date_string = date_string;
        tags.push(tag);
      });
      // filter QR Codes by payload.filter and payload.search
      let sort_key;
      let is_reversed;
      if(payload.filter == 'Latest') {
        tags = tags.filter(qr =>
          qr.description.toLowerCase().includes(payload.search.toLowerCase()) ||
          qr.date.toLowerCase().includes(payload.search.toLowerCase()) ||
          qr.user_email.first_name.toLowerCase().includes(payload.search.toLowerCase()) ||
          qr.user_email.last_name.toLowerCase().includes(payload.search.toLowerCase()) ||
          qr.user_email.email.toLowerCase().includes(payload.search.toLowerCase())
        );
        sort_key = 'created';
        is_reversed = true;
      }
      else if(payload.filter == 'Description') {
        tags = tags.filter(qr => qr.description.toLowerCase().includes(payload.search.toLowerCase()));
        sort_key = 'description';
      }
      else if(payload.filter == 'Date') {
        tags = tags.filter(qr => qr.created.toLowerCase().includes(payload.search.toLowerCase()));
        sort_key = 'created';
        is_reversed = true;
      }
      else if(payload.filter == 'Person') {
        tags = tags.filter(qr => qr.person_string.toLowerCase().includes(payload.search.toLowerCase()));
        sort_key = 'person_string';
      }
      getters.sortObjectArrayByValueOfKey({array: tags, sort_key});
      if(is_reversed) {
        tags.reverse();
      }
      if(!tags.length) {
        return [];
      }
      // cathegroize tags by payload.filter
      let qr_code_arr = [];
      let arr_idx = -1;
      switch (payload.filter) {
        case 'Description':
        for(let i = 0; i < tags.length; i++) {
          if(
            qr_code_arr[arr_idx] &&
            tags[i].description[0].toUpperCase() === qr_code_arr[arr_idx].category
          ) {
            qr_code_arr[arr_idx].data.push(tags[i]);
          }
          else {
            arr_idx++;
            qr_code_arr.push({
              category: tags[i].description[0].toUpperCase(),
              data: [tags[i]]
            });
          }
        }
        return qr_code_arr;
        case 'Date':
        for(let i = 0; i < tags.length; i++) {
          if(
            qr_code_arr[arr_idx] &&
            tags[i].date_string === qr_code_arr[arr_idx].category
          ) {
            qr_code_arr[arr_idx].data.push(tags[i]);
          }
          else {
            arr_idx++;
            qr_code_arr.push({
              category: tags[i].date_string,
              data: [tags[i]]
            });
          }
        }
        return qr_code_arr;

        case 'Person':
        for(let i = 0; i < tags.length; i++) {
          if(
            qr_code_arr[arr_idx] &&
            tags[i].person_string === qr_code_arr[arr_idx].category
          ) {
            qr_code_arr[arr_idx].data.push(tags[i]);
          }
          else {
            arr_idx++;
            qr_code_arr.push({
              category: tags[i].person_string,
              data: [tags[i]]
            });
          }
        }
        return qr_code_arr;
        default:
        return [{ category: '', data: tags }];
      }

    }
    return [{ category: '', data: [] }];
  },
  sortObjectArrayByValueOfKey: () => (payload) => {
    payload.array.sort((a, b) => {
      // we check every char if they're the same, if not sort accordingly
      // TODO: check for ö, ä, ü, ß
      let min = Math.min(a[payload.sort_key].length, b[payload.sort_key].length);
      for(let i = 0; i < min; i++) {
        if(a[payload.sort_key][i].toLowerCase() !== b[payload.sort_key][i].toLowerCase()) {
          return a[payload.sort_key][i].toLowerCase() > b[payload.sort_key][i].toLowerCase() ? 1 : -1;
        }
      }
      // all chars were the same, shorter string is prioritized
      if(a[payload.sort_key].length != b[payload.sort_key].length) {
        return a[payload.sort_key].length === min ? -1 : 1;
      }
      // string matches exactly, no preference
      return 0;
    });
  },
};
// Actions
const actions = {
  // TODO: request Tags -> backend fehlt
  //local tworkpackage variables
  requestTWorkPackagesInvoiceable({commit}, payload) {
  return new Promise((resolve, reject) => {
    axios({
      url: 'projects/' + payload.project_id + '/invoiceabletworkpackages',
      method: 'GET'
    })
    .then(resp => {
      let invoiceable_twork_packages = {};
      for (var i = 0; i < resp.data.data.length; i++) {

        // `${state.week_days[calendar.takt_times[i].dates[0].getDay()]} ${calendar.takt_times[i].dates[0].toISOString().substring(8, 10)}`;
        if (!invoiceable_twork_packages[resp.data.data[i].takt_position]) {
          invoiceable_twork_packages[resp.data.data[i].takt_position] = [];
        }
        let days = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
        let twp = JSON.parse(JSON.stringify(resp.data.data[i]));
        twp.first_day = `${days[new Date(twp.first_date.date).getDay()]} ${new Date(twp.first_date.date).getDate()}`;
        twp.last_day = `${days[new Date(twp.last_date.date).getDay()]} ${new Date(twp.last_date.date).getDate()}`;
        invoiceable_twork_packages[resp.data.data[i].takt_position].push(twp);
      }
      commit('set_invoiceable_twork_packages', invoiceable_twork_packages);
      resolve();
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      reject();
    });
  });
},
  createInvoicePreview({commit}, payload){
    axios({
      url: 'projects/' + payload.project_id + '/invoicetemplate',
      method: 'POST',
      data: payload.payload
    })
    .then(resp => {
      commit('set_invoice_preview', resp.data.data);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },

  //with local mutations mutating Ultra store state
  requestCreateInvoice({commit, rootState}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'projects/' + payload.project_id + '/invoices',
        method: 'POST',
        data: payload.payload
      })
      .then(resp => {
        commit('set_invoice', resp.data.data);
        commit('Project/project_add_owner_invoice', {rootState, payload: {project_id: payload.project_id, invoice: resp.data.data}}, { root: true });
        resolve(resp.data.data);
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject(err.response.data.error_msg);
      });
    });
  },
  addStepImage({commit, rootState}, payload) {
    commit('add_step_image', {rootState, payload});
  },
  addTWPTag({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'projects/' + payload.project_id + '/trains/' + payload.train_id + '/taktareas/' + payload.taktarea_id + '/twaggons/' + payload.twaggon_id + '/tworkpackages/' + payload.tworkpackage_id + '/addtag' ,
        method: 'PUT',
        data: payload.data
      })
      .then(() => {
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        reject(err.response.data.error_msg);
      });
    });
  },
  requestTags({commit}, payload) {
    axios({
      url: 'projects/' + payload.project_id + '/tags',
      method: 'GET',
    })
    .then(res => {
      commit('set_tags', res.data.data);
    });
  },
  requestConfidence({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: 'projects/' + payload.project_id + '/trains/' + payload.train_id + '/taktareas/' + payload.taktarea_id + '/twaggons/' + payload.twaggon_id + '/tworkpackages/' + payload.tworkpackage_id + '/tworkpackageimages/' + payload.image_id + '/confidence' ,
        method: 'GET'
      })
      .then(res => {
        commit('set_image_confidence', res.data.data);
        resolve();
      })
      .catch(err => {
        commit('set_image_confidence', {
          confidence_drywall: 0,
          confidence_electrical: 0,
          confidence_paint: 0
        });
        // commit('set_error', extractErrorDetails(err));
        reject(err.response.data.error_msg);
      });
    });
  },
  validQRCode({commit}, payload){
    return new Promise((resolve) => {
      let headers = {
        'Cache-Control': 'no-cache'
      };
      axios({
        url: 'projects/' + payload.project_id + '/tags/' + '0?code=' + payload.code + '&signature=' + payload.signature,
        method: 'GET',
        headers: headers
      })
      .then(() => {
        commit('View/set_user_feedback', 'QR.code is already in use', { root: true });
      })
      .catch(err => {
        switch (err.response.status) {
          case 404:
            resolve();
            break;
          case 409:
            commit('View/set_user_feedback', 'QR.code is not from TAKT.ing', { root: true });
            break;
          case 403:
            commit('View/set_user_feedback', 'QR.code is already in use', { root: true });
            break;
          default:
            commit('View/set_user_feedback', 'invalid QR.code', { root: true });
        }
      });
    });
  },
  createQRCode({commit, dispatch, rootState}, payload){
    let url = payload.workpackage_url;
    if (payload.code.link_type != `${payload.prefix}workpackages`) {
      let url_prefix = {};
      url_prefix[payload.code.link_type] = payload.code.link_id;
      url.push(url_prefix);
    }
    url.push({tags: ''});
    url.push({showWithEntitiesNormalized: ''});
    dispatch('Ultra/createUObject', {
      url: url,
      u_object: payload.code
    }, {root:true})
    .then(resp => {
      payload.id = resp;
      if(payload.code.link_type != `${payload.prefix}workpackages`) {
        commit('add_tag_to_tworkpackage', {rootState, payload});
      }
    });
  },
  deleteQRCode({commit, rootState}, payload){
    return new Promise((resolve) => {
      axios({
        url: 'projects/' + payload.project_id + '/tags/' + payload.tag.id,
        method: 'DELETE',
        headers: {
          'Cache-Control': 'no-cache'
        },
        data: {
          edit_key: rootState.Project.edit_key
        }
      })
      .then(() => {
        commit('remove_tag', {rootState, payload});
        resolve();
      }).catch((err) => {
        commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
      });
    });
  }
};
// Mutations
const mutations = {
  //local mutations
  set_error(state, err) {
    state.error = err;
  },
  set_invoiceable_twork_packages(state, twork_packages){
    state.invoiceable_twork_packages = twork_packages;
  },
  set_invoice_preview(state, invoice_preview){
    state.invoice_preview = invoice_preview;
  },
  set_invoice(state, invoice){
    state.invoice = invoice;
  },
  set_tags(state, data){
    state.tags = data;
  },
  //ultra store state mutations
  add_step_image(state, {rootState, payload}) {
    rootState.Ultra.tworkpackages[payload.tworkpackage_id].tworkpackageimages.push(payload.image_id);
  },
  append_twork_step(rootState, payload){
    if (!rootState.Ultra.tworkpackages[payload.twork_package_id].twork_steps) {
      rootState.Ultra.tworkpackages[payload.twork_package_id].twork_steps = [];
    }
    rootState.Ultra.tworkpackages[payload.twork_package_id].twork_steps.push(payload.twork_step);
    rootState.Ultra.tworkpackages[payload.twork_package_id].twork_step_count =
    rootState.Ultra.tworkpackages[payload.twork_package_id].twork_steps.length;
  },
  append_tquality_step(rootState, payload){
    if (!rootState.Ultra.tworkpackages[payload.twork_package_id].tquality_steps) {
      rootState.Ultra.tworkpackages[payload.twork_package_id].tquality_steps = [];
    }
    rootState.Ultra.tworkpackages[payload.twork_package_id].tquality_steps.push(payload.tquality_step);
    rootState.Ultra.tworkpackages[payload.twork_package_id].tquality_step_count =
    rootState.Ultra.tworkpackages[payload.twork_package_id].tquality_steps.length;
  },
  append_tdefect_step(rootState, payload){
    if (!rootState.Ultra.tworkpackages[payload.twork_package_id].tdefect_steps) {
      rootState.Ultra.tworkpackages[payload.twork_package_id].tdefect_steps = [];
    }
    rootState.Ultra.tworkpackages[payload.twork_package_id].tdefect_steps.push(payload.tdefect_step);
    rootState.Ultra.tworkpackages[payload.twork_package_id].tdefect_step_count =
    rootState.Ultra.tworkpackages[payload.twork_package_id].tdefect_steps.length;
  },
  append_thandover_step(rootState, payload){
    if (!rootState.Ultra.tworkpackages[payload.twork_package_id].thandover_steps) {
      rootState.Ultra.tworkpackages[payload.twork_package_id].thandover_steps = [];
    }
    rootState.Ultra.tworkpackages[payload.twork_package_id].thandover_steps.push(payload.thandover_step);
    rootState.Ultra.tworkpackages[payload.twork_package_id].thandover_step_count =
    rootState.Ultra.tworkpackages[payload.twork_package_id].thandover_steps.length;
  },
  append_tdesign_step(rootState, payload){
    if (!rootState.Ultra.tworkpackages[payload.twork_package_id].tdesign_steps) {
      rootState.Ultra.tworkpackages[payload.twork_package_id].tdesign_steps = [];
    }
    rootState.Ultra.tworkpackages[payload.twork_package_id].tdesign_steps.push(payload.tdesign_step);
    rootState.Ultra.tworkpackages[payload.twork_package_id].tdesign_step_count =
    rootState.Ultra.tworkpackages[payload.twork_package_id].tdesign_steps.length;
  },
  append_tlogistic_step(rootState, payload){
    if (!rootState.Ultra.tworkpackages[payload.twork_package_id].tlogistic_steps) {
      rootState.Ultra.tworkpackages[payload.twork_package_id].tlogistic_steps = [];
    }
    rootState.Ultra.tworkpackages[payload.twork_package_id].tlogistic_steps.push(payload.tlogistic_step);
    rootState.Ultra.tworkpackages[payload.twork_package_id].tlogistic_step_count =
    rootState.Ultra.tworkpackages[payload.twork_package_id].tlogistic_steps.length;
  },
  set_twork_steps(rootState, payload){
    let twork_steps = [];
    for (let i = 0; i < payload.twork_steps.length; i++) {
      twork_steps.push(payload.twork_steps[i].id);
    }
    Vue.set(rootState.Ultra.tworkpackages[payload.twork_package_id], 'twork_steps', twork_steps);
  },
  set_tquality_steps(rootState, payload){
    let tquality_steps = [];
    for (let i = 0; i < payload.tquality_steps.length; i++) {
      tquality_steps.push(payload.tquality_steps[i].id);
    }
    Vue.set(rootState.Ultra.tworkpackages[payload.twork_package_id], 'tquality_steps', tquality_steps);
  },
  set_tdefect_steps(rootState, payload){
    let tdefect_steps = [];
    for (let i = 0; i < payload.tdefect_steps.length; i++) {
      tdefect_steps.push(payload.tdefect_steps[i].id);
    }
    Vue.set(rootState.Ultra.tworkpackages[payload.twork_package_id], 'tdefect_steps', tdefect_steps);
  },
  set_thandover_steps(rootState, payload){
    let thandover_steps = [];
    for (let i = 0; i < payload.thandover_steps.length; i++) {
      thandover_steps.push(payload.thandover_steps[i].id);
    }
    Vue.set(rootState.Ultra.tworkpackages[payload.twork_package_id], 'thandover_steps', thandover_steps);
  },
  set_tdesign_steps(rootState, payload){
    let tdesign_steps = [];
    for (let i = 0; i < payload.tdesign_steps.length; i++) {
      tdesign_steps.push(payload.tdesign_steps[i].id);
    }
    Vue.set(rootState.Ultra.tworkpackages[payload.twork_package_id], 'tdesign_steps', tdesign_steps);
  },
  set_tlogistic_steps(rootState, payload){
    let tlogistic_steps = [];
    for (let i = 0; i < payload.tlogistic_steps.length; i++) {
      tlogistic_steps.push(payload.tlogistic_steps[i].id);
    }
    Vue.set(rootState.Ultra.tworkpackages[payload.twork_package_id], 'tlogistic_steps', tlogistic_steps);
  },
  set_tcost_steps(rootState, payload){
    let tcost_steps = [];
    for (let i = 0; i < payload.tcost_steps.length; i++) {
      tcost_steps.push(payload.tcost_steps[i].id);
    }
    Vue.set(rootState.Ultra.tworkpackages[payload.twork_package_id], 'tcost_steps', tcost_steps);
  },
  delete_tworkpackage_file(state, payload){
    state.twork_packages[payload.twork_package_id].tlogistic_steps.splice(payload.tlogistic_step.index, 1);
    state.twork_packages[payload.twork_package_id].tlogistic_step_count =
    state.twork_packages[payload.twork_package_id].tlogistic_steps.length;
  },
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  twork_package_insert(rootState, payload) {
    Vue.set(rootState.Ultra.tworkpackages, payload.id, payload);
  },
  twork_package_delete(rootState, payload) {
    delete rootState.Ultra.tworkpackages[payload.twork_package_id];
  },
  twork_package_loading(state, loading) {
    state.loading = loading;
  },
  single_twork_package_success(rootState, twork_package) {
    rootState.Ultra.tworkpackages[twork_package.id] = twork_package;
  },
  twork_packages_success(state, payload) {
    Vue.set(state, 'twork_packages', payload);
  },
  twork_packages_insert_bulk(rootState, payload) {
    rootState.Ultra.tworkpackages = Object.assign({}, rootState.Ultra.tworkpackages, payload);
  },
  update_twork_package(rootState, payload){
    delete payload.update.edit_key;
    Vue.set(rootState.Ultra.tworkpackages, payload.twork_package_id, Object.assign(rootState.Ultra.tworkpackages[payload.twork_package_id], payload.update));
  },
  update_twork_package_bulk(rootState, payload){
    for (let i = 0; i < payload.work_packages.length; i++) {
      Vue.set(rootState.Ultra.tworkpackages, payload.work_packages[i].id, Object.assign(rootState.Ultra.tworkpackages[payload.work_packages[i].id], payload.update));
    }
  },
  twork_step_change_position(rootState, payload) {
    let twork_steps = rootState.Ultra.tworkpackages[payload.twork_package_id].twork_steps;
    twork_steps.splice(payload.drag_evt.newIndex, 0, twork_steps.splice(payload.drag_evt.oldIndex, 1)[0]);
  },
  tquality_step_change_position(rootState, payload) {
    let tquality_steps = rootState.Ultra.tworkpackages[payload.twork_package_id].tquality_steps;
    tquality_steps.splice(payload.drag_evt.newIndex, 0, tquality_steps.splice(payload.drag_evt.oldIndex, 1)[0]);
  },
  tdefect_step_change_position(rootState, payload) {
    let tdefect_steps = rootState.Ultra.tworkpackages[payload.twork_package_id].tdefect_steps;
    tdefect_steps.splice(payload.drag_evt.newIndex, 0, tdefect_steps.splice(payload.drag_evt.oldIndex, 1)[0]);
  },
  thandover_step_change_position(rootState, payload) {
    let thandover_steps = rootState.Ultra.tworkpackages[payload.twork_package_id].thandover_steps;
    thandover_steps.splice(payload.drag_evt.newIndex, 0, thandover_steps.splice(payload.drag_evt.oldIndex, 1)[0]);
  },
  tdesign_step_change_position(rootState, payload) {
    let tdesign_steps = rootState.Ultra.tworkpackages[payload.twork_package_id].tdesign_steps;
    tdesign_steps.splice(payload.drag_evt.newIndex, 0, tdesign_steps.splice(payload.drag_evt.oldIndex, 1)[0]);
  },
  tlogistic_step_change_position(rootState, payload) {
    let tlogistic_steps = rootState.Ultra.tworkpackages[payload.twork_package_id].tlogistic_steps;
    tlogistic_steps.splice(payload.drag_evt.newIndex, 0, tlogistic_steps.splice(payload.drag_evt.oldIndex, 1)[0]);
  },
  set_image_confidence(state, payload) {
    state.image_confidence = payload;
  },
  add_tag_to_tworkpackage(state, {rootState, payload}) {
    rootState.Ultra[`${payload.prefix}workpackages`][payload.workpackage_id].tags.push(payload.id);
  },
  remove_tag(state, {rootState, payload}) {
    Vue.delete(rootState.Ultra.tags, payload.tag.id);
    payload.tag.link_type = payload.tag.link_type.toLowerCase();
    let index_wp = rootState.Ultra[`${payload.prefix}workpackages`][payload.workpackage_id].tags.indexOf(payload.tag.id);
    rootState.Ultra[`${payload.prefix}workpackages`][payload.workpackage_id].tags.splice(index_wp, 1);
    let index = rootState.Ultra[payload.tag.link_type][payload.tag.link_id].tags.indexOf(payload.tag.id);
    if (index != -1){
      rootState.Ultra[payload.tag.link_type][payload.tag.link_id].tags.splice(index, 1);
    }
  },
  okay(){

  },
};

function isInFilter(settings, twp) {
    let add_color = false;
    let add_icon = false;
  
    // settings
    if (settings['colors'].includes(twp.color) || settings['colors'].length === 0) {
      add_color = true;
    }
  
    if (settings['icons'].includes(twp.icon) || settings['icons'].length === 0) {
      add_icon = true;
    }
  
    return add_color && add_icon;
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
